import { render } from "./DropdownLanguageList.vue?vue&type=template&id=3ed11c5a"
import script from "./DropdownLanguageList.vue?vue&type=script&lang=js"
export * from "./DropdownLanguageList.vue?vue&type=script&lang=js"

import "./DropdownLanguageList.vue?vue&type=style&index=0&id=3ed11c5a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__